import { createSelector } from '@reduxjs/toolkit';
// Models
import { SLICE_NAME } from './pagesToolbar.models';

export const selectNewDesignEnabled = (state:any) => state[SLICE_NAME].newDesignEnabled;
export const selectFiltersSidebarOpen = (state:any) => state[SLICE_NAME].filtersSidebarOpen;
export const selectSelectedPageIds = (state:any) => state[SLICE_NAME].selectedPageIds;
export const selectLoadingPageIds = (state:any) => state[SLICE_NAME].loadingPageIds;

export const selectIsPageSelected = createSelector(
  [
    selectSelectedPageIds,
    (_:any, props:{ documentId:number; pageNum:number }) => props
  ],
  (selectedPageIds:string[], { documentId, pageNum }) => {
    const pageId = `${documentId}:${pageNum}`;
    return selectedPageIds.includes(pageId);
  }
);

export const selectIsPageLoading = createSelector(
  [
    selectLoadingPageIds,
    (_:any, props:{ documentId:number; pageNum:number }) => props
  ],
  (loadingPageIds:string[], { documentId, pageNum }) => {
    const pageId = `${documentId}:${pageNum}`;
    return loadingPageIds.includes(pageId);
  }
);
